<h2 mat-dialog-title>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.WEB_PAGES' | translate }}</h2>
<mat-dialog-content>
  <glxy-form-field>
    <glxy-label>{{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.PICK_PAGES' | translate }}</glxy-label>
    <ng-container [formGroup]="form">
      <ng-container formArrayName="pages">
        @for (page of sortedWebPages; let i = $index; track i) {
          <mat-checkbox [formControlName]="i">
            {{ page.title }}
            <extended>{{ page.url }}</extended>
          </mat-checkbox>
        }
      </ng-container>
    </ng-container>
  </glxy-form-field>
</mat-dialog-content>

<mat-dialog-actions>
  <button mat-stroked-button mat-dialog-close>{{ 'AI_ASSISTANT.SHARED.CANCEL' | translate }}</button>
  <button mat-flat-button color="primary" (click)="train()">
    {{ 'AI_ASSISTANT.KNOWLEDGE_ACCESS.TRAIN' | translate }}
  </button>
</mat-dialog-actions>
